<template>
	<div class="view">
		<div class="all-content">
			<ProjectFilter></ProjectFilter>
			<div class="projects">
				<div class="filter-heading text-white"><center>projects</center></div>
				<div class="options">
					<OptionProject v-for="(projects_option, index) in options_to_show" :key="index" :index="index" :projects_option="projects_option">
						<p>{{ projects_option.year }}</p>
					</OptionProject>
				</div>
			</div>
		</div>
		<project-details v-if="showing_project_details" :project_details="target_project"></project-details>
	</div>
</template>

<script>
import ProjectFilter from '@/components/ProjectFilter';
import ProjectsFile from '@/content/projects.json';
import OptionProject from '@/components/OptionProject';
import ProjectDetails from '@/views/ProjectDetails';
import  emitter  from '@/emitter';

export default {
	name: 'projects',
	metaInfo: {
		title: 'Projects',
		meta: [
			{
				property: 'og:url',
				content: 'http://www.dyelec.co.ls/projects'
			},
			{
				property: 'og:title', 
				content: 'Dyelec Lesotho | Projects'
			},
			{
				name: 'description', 
				content: 'Our range of professional services at Dyelec Lesotho includes design, tender documentation, construction supervision and contract management for the following installations: Standby Power Supply Systems, Fire Protection, Alarm and Detection,Electronic System and Security Systems,Telephone Services Installations, and others'
			},
			{
				property: 'og:description', 
				content: 'Our range of professional services at Dyelec Lesotho includes design, tender documentation, construction supervision and contract management for the following installations: Standby Power Supply Systems, Fire Protection, Alarm and Detection,Electronic System and Security Systems,Telephone Services Installations, and others'
			},
			// Twitter card
			{
				name: 'twitter:card',
				content: 'Dyelec Lesotho'
			},
			{
				name: 'twitter:title',
				content: 'Dyelec Lesotho | Projects'
			},
			{
				name: 'twitter:description',
				content: 'Our range of professional services at Dyelec Lesotho includes design, tender documentation, construction supervision and contract management for the following installations: Standby Power Supply Systems, Fire Protection, Alarm and Detection,Electronic System and Security Systems,Telephone Services Installations, and others'
			}
		]
		// override the parent template and just use the above title only
		// titleTemplate: null
	},
	components: {
		ProjectFilter, OptionProject, ProjectDetails
	},
	data() {
		return {
			projects: [...ProjectsFile.projects].sort((a,b)=>{
				return Number(a.year) - Number(b.year);
			}),
			options_to_show: null,
			target_project: null,
			showing_project_details: false,
			filter: 'all'
		};
	},
	created() {
		emitter.$on('hide-project-details', this.hideProjectDetails);
		emitter.$on('projects-filter', this.filterOptions);
	},
	destroyed() {
		emitter.$off('hide-project-details', this.hideProjectDetails);
	},
	mounted() {
		emitter.$emit('new-page-name', 'Projects');
		if (typeof NodeList.prototype.forEach !== 'function')  {
			NodeList.prototype.forEach = Array.prototype.forEach;
		}
	},
	methods: {
		hideProjectDetails() {
			this.showing_project_details = false;
			this.target_project = null;
		},
		filterOptions(options_filter) {
			if(Array.isArray(options_filter)) {
				if(options_filter.length === 0) {
					this.options_to_show = this.projects;
				} else {
					this.options_to_show = [];
					this.$nextTick(()=>{
						const temp = this.projects.filter( project => {
							return options_filter.includes(project.category.replace(RegExp(/\W*/igm),''));
						});
						if(this.options_to_show !== temp){
							temp.forEach((_option, _index)=>{
								this.$set(this.options_to_show, _index, temp[_index]);
							});
						}
					});
				}
			}
		}
	},
	watch: {
		'$route.query'(to) {
			if(to) {
				if(to.pd) {
					if(this.projects.find((_project)=>{return _project.id === to.pd;})) {
						this.target_project = this.projects.find((_project)=>{
							return _project.id === to.pd;
						});
						this.showing_project_details = true;
					} else {
						alert('It seems like the full details to this project are not available. Please refresh the page and try again.');
					}
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
	@import '../assets/style/main.scss';
	.all-content {

		animation: slide-up 500ms ease-in-out both;
		z-index: -1;
		width: 100%;
		align-self: center;
		display: flex;
		>.projects {
			flex-grow: 1;
			>.filter-heading {
				letter-spacing: 0.5ch;
				font-size: 1.5em;
				margin-top: 1em;
				margin-bottom: 1em;
				position: relative;
				text-align: center;
				&::before {
					position: absolute;
					bottom: -0.3em;
					left: calc(34%);
					width: 30%;
					height: 1px;
					content: '';
					background-color: $white;
					opacity: 0.5;
				}
			}
			>.options {
				width: 100%;
				display: grid;
				grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
				grid-column-gap: 12px;
				grid-row-gap: 24px;
				justify-content: center;
				grid-auto-flow:  row dense;
				align-items: flex-start;
				padding: 0em 1em;
			}
		}
	}
	@media (max-width: 767px) {
		.all-content {
			padding: 0em;
			flex-wrap: wrap;
			justify-content: center;
			>.projects{
				>.filter-heading {
					margin-top: 2em;
					&::before {
						left: 25%;
						width: 50%;
					}
				}
				>.options {
					grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
				}
			}
		}
	}
</style>